import {useStorage} from "@variocube/app-ui";

export function useInfoFilter() {
	return useStorage("InfoFilter", {});
}
